import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement, useRef, useEffect, Fragment } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { Badge } from '../Badge/Badge.js';
import { PopoverDisclosure, Popover } from 'reakit/Popover';
import { useBoundingClientRectListener } from '../../utils/hooks/useBoundingClientRectListener.js';
import { Combobox } from '../Combobox/Combobox.js';
import { MultiListbox, Listbox } from '../Listbox/Listbox.js';
import { useSelect } from './useSelect.js';

var _excluded = ["autoFocus", "className", "highlighted", "style"],
    _excluded2 = ["container"],
    _excluded3 = ["editable"];
var BaseSelect = /*#__PURE__*/forwardRef(function BaseSelect(props, ref) {
  var _cn;

  var autoFocus = props.autoFocus,
      externalClassName = props.className,
      highlighted = props.highlighted,
      style = props.style,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useSelect = useSelect(otherProps, ref),
      button = _useSelect.button,
      listbox = _useSelect.listbox,
      popover = _useSelect.popover,
      text = _useSelect.text,
      _useSelect$more = _useSelect.more,
      more = _useSelect$more === void 0 ? 0 : _useSelect$more;

  var container = popover.container,
      base = _objectWithoutPropertiesLoose(popover, _excluded2);

  var internalRef = useRef(null);
  var selectDimensions = useBoundingClientRectListener(internalRef);
  var className = cn('yt-select', {
    'yt-select--readonly': props.readOnly
  }, externalClassName);
  var inputClassname = cn('yt-input group', (_cn = {}, _cn["yt-input--state-" + otherProps.state] = !!otherProps.state, _cn['yt-input--highlighted'] = highlighted, _cn));
  useEffect(function () {
    if (autoFocus && internalRef.current) {
      internalRef.current.focus();
    }
  }, []);

  var renderMultiSelection = function renderMultiSelection() {
    return createElement(Fragment, null, createElement("span", null, text), more > 0 && createElement(Badge, {
      className: "ml-2"
    }, "+" + more));
  };

  var commonListboxProps = _extends({}, listbox, {
    className: 'w-auto',
    style: {
      minWidth: selectDimensions === null || selectDimensions === void 0 ? void 0 : selectDimensions.width
    },
    tabIndex: popover.visible ? 0 : -1
  });

  return createElement("span", {
    className: className,
    style: style
  }, createElement(PopoverDisclosure, Object.assign({}, base, {
    ref: internalRef
  }), function (_ref) {
    var disclosureRef = _ref.ref;
    return createElement("button", Object.assign({
      ref: disclosureRef
    }, button, {
      className: inputClassname
    }), props.multiselect ? renderMultiSelection() : createElement("span", null, text), createElement("span", {
      className: "h-8 w-8 flex items-center justify-center"
    }, createElement(Icon, {
      className: "text-black group-hover:text-grey-darkest",
      name: popover.visible ? 'chevron-up' : 'chevron-down'
    })));
  }), !otherProps.disabled && createElement(Popover, Object.assign({}, base, container), props.multiselect ? createElement(MultiListbox, Object.assign({}, commonListboxProps)) : createElement(Listbox, Object.assign({}, commonListboxProps))));
});
var Select = /*#__PURE__*/forwardRef(function Select(props, ref) {
  var editable = props.editable,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded3);

  if (editable) {
    return createElement(Combobox, Object.assign({}, otherProps, {
      inline: true,
      ref: ref
    }));
  }

  return createElement(BaseSelect, Object.assign({}, otherProps, {
    ref: ref
  }));
});

export { Select };
//# sourceMappingURL=Select.js.map
